import { Switch } from "antd";
import { useNotification } from "../../../../hooks/useNotification";
import { useUpdateShopifyStoreMutation } from "../../../../store/apiSlice/shopifyApiSlice";

/**
 * Per-store Active toggle for the Shopify stores list.
 * Enable/disable is per store (no global Shopify switch on the hub card).
 */
export const ShopifyStoreActiveToggle = ({ store }) => {
  const [updateStore, { isLoading }] = useUpdateShopifyStoreMutation();
  const notify = useNotification();

  const handleChange = async is_active => {
    const { error } = await updateStore({ id: store.id, data: { is_active } });
    if (error) {
      notify({
        type: "error",
        message: error?.data?.detail || "Failed to update store status.",
      });
    }
  };

  return (
    <td key="store_active" onClick={e => e.stopPropagation()}>
      <Switch
        size="small"
        title="active"
        checked={store.is_active}
        loading={isLoading}
        onChange={handleChange}
      />
    </td>
  );
};
